"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeGraphicsComponent = void 0;
/**
 * @internal
 */
function initializeGraphicsComponent(renderer, component) {
    const componentRenderer = renderer.componentRendererProvider.initializeRenderer(component, () => {
        return renderer.componentRendererFactory.createRenderer(component.specification);
    });
    componentRenderer.onBeforeInitialization();
    component.initialize(componentRenderer);
    componentRenderer.onAfterInitialization();
    renderer.graphicsComponents.setComponent(component);
}
exports.initializeGraphicsComponent = initializeGraphicsComponent;
//# sourceMappingURL=initialize-graphics-component.js.map